import DtoReferencial from './DtoReferencial'

export default class DtoQualitometerRepresentiveness extends DtoReferencial {
    constructor(obj) {
        super(obj)
    }
}
